import script from "./edit_job.vue?vue&type=script&setup=true&lang=js"
export * from "./edit_job.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__